/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './hosp-patient-cat-misc-charges.reducer';

export const HospPatientCatMiscChargesDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const hospPatientCatMiscChargesEntity = useAppSelector(state => state.hospPatientCatMiscCharges.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="hospPatientCatMiscChargesDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.hospPatientCatMiscCharges.detail.title">HospPatientCatMiscCharges</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.hospPatientCatMiscCharges.id">Id</Translate>
            </span>
          </dt>
          <dd>{hospPatientCatMiscChargesEntity.id}</dd>
          <dt>
            <span id="multiplier">
              <Translate contentKey="tinyMedicRestApp.hospPatientCatMiscCharges.multiplier">Multiplier</Translate>
            </span>
          </dt>
          <dd>{hospPatientCatMiscChargesEntity.multiplier}</dd>
          <dt>
            <span id="multiplierFlag">
              <Translate contentKey="tinyMedicRestApp.hospPatientCatMiscCharges.multiplierFlag">Multiplier Flag</Translate>
            </span>
          </dt>
          <dd>{hospPatientCatMiscChargesEntity.multiplierFlag ? 'true' : 'false'}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.hospPatientCatMiscCharges.active">Active</Translate>
            </span>
          </dt>
          <dd>{hospPatientCatMiscChargesEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.hospPatientCatMiscCharges.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{hospPatientCatMiscChargesEntity.cursor}</dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.hospPatientCatMiscCharges.lastUpdated">Last Updated</Translate>
            </span>
          </dt>
          <dd>{hospPatientCatMiscChargesEntity.lastUpdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.hospPatientCatMiscCharges.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{hospPatientCatMiscChargesEntity.microSec}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.hospPatientCatMiscCharges.timestampEntry">Timestamp Entry</Translate>
            </span>
          </dt>
          <dd>{hospPatientCatMiscChargesEntity.timestampEntry}</dd>
          <dt>
            <span id="chargeAmount">
              <Translate contentKey="tinyMedicRestApp.hospPatientCatMiscCharges.chargeAmount">Charge Amount</Translate>
            </span>
          </dt>
          <dd>{hospPatientCatMiscChargesEntity.chargeAmount}</dd>
          <dt>
            <span id="taxPercent">
              <Translate contentKey="tinyMedicRestApp.hospPatientCatMiscCharges.taxPercent">Tax Percent</Translate>
            </span>
          </dt>
          <dd>{hospPatientCatMiscChargesEntity.taxPercent}</dd>
          <dt>
            <span id="startDate">
              <Translate contentKey="tinyMedicRestApp.hospPatientCatMiscCharges.startDate">Start Date</Translate>
            </span>
          </dt>
          <dd>{hospPatientCatMiscChargesEntity.startDate}</dd>
          <dt>
            <span id="endDate">
              <Translate contentKey="tinyMedicRestApp.hospPatientCatMiscCharges.endDate">End Date</Translate>
            </span>
          </dt>
          <dd>{hospPatientCatMiscChargesEntity.endDate}</dd>
          <dt>
            <span id="suspended">
              <Translate contentKey="tinyMedicRestApp.hospPatientCatMiscCharges.suspended">Suspended</Translate>
            </span>
          </dt>
          <dd>{hospPatientCatMiscChargesEntity.suspended ? 'true' : 'false'}</dd>
          <dt>
            <span id="draft">
              <Translate contentKey="tinyMedicRestApp.hospPatientCatMiscCharges.draft">Draft</Translate>
            </span>
          </dt>
          <dd>{hospPatientCatMiscChargesEntity.draft ? 'true' : 'false'}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.hospPatientCatMiscCharges.patientCategory">Patient Category</Translate>
          </dt>
          <dd>{hospPatientCatMiscChargesEntity.patientCategory ? hospPatientCatMiscChargesEntity.patientCategory.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.hospPatientCatMiscCharges.charge">Charge</Translate>
          </dt>
          <dd>{hospPatientCatMiscChargesEntity.charge ? hospPatientCatMiscChargesEntity.charge.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.hospPatientCatMiscCharges.hospital">Hospital</Translate>
          </dt>
          <dd>{hospPatientCatMiscChargesEntity.hospital ? hospPatientCatMiscChargesEntity.hospital.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/hosp-patient-cat-misc-charges" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/hosp-patient-cat-misc-charges/${hospPatientCatMiscChargesEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default HospPatientCatMiscChargesDetail;
